export const AGENT_WORKFLOW_FEATURE_FLAG = "agent_workflow";
export const AGENT_WORKFLOW_TRACES_FEATURE_FLAG = "agent_workflow_traces";
